import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import Metadata from '@pray/shared/components/Metadata';
import { useTheme } from '@pray/shared/contexts';
import type { Plan, RecurringPeriod } from '@pray/shared/data/pricing/types';

import { additionalIdentifyUser } from '@/utils/analytics/hubspot/tracking';
import useAppRoutes from 'hooks/useAppRoutes';

import Pricing from './components/Pricing';
import Footer from '../../components/Footer/Footer';
import { Header } from '../../components/Header/Header';
import { PRODUCT_LABELS, Products } from '../../types/products';

export default function PricingPage() {
  const appRoutes = useAppRoutes();
  const navigate = useNavigate();
  const { setColorMode } = useTheme();

  useEffect(() => {
    setColorMode('dark');
  }, [setColorMode]);

  const handlePlanSelect = (plan: Plan, recurringPeriod: RecurringPeriod) => {
    additionalIdentifyUser({
      plan_name: plan.name,
      recurring__monthly_or_yearly_: recurringPeriod,
      price: plan.pricing[recurringPeriod].price.toString(),
    });

    const product = plan.pricing[recurringPeriod];

    const searchParams = new URLSearchParams({
      product_id: product.id,
      interval: recurringPeriod,
    });

    navigate({
      pathname: appRoutes.getStarted(),
      search: searchParams.toString(),
    });
  };

  return (
    <div>
      <Metadata
        title={`${PRODUCT_LABELS[Products.PRAYSTUDIO]} Software Pricing`}
        description={`See pricing for ${
          PRODUCT_LABELS[Products.PRAYSTUDIO]
        }'s all-in-one solution to help grow your digital ministry. `}
      />
      <Header />
      <div className="py-8">
        <Pricing onPlanSelect={handlePlanSelect} />
      </div>
      <Footer />
    </div>
  );
}
